import { connect } from 'react-redux';
import { assign } from 'lodash';
import BaseForm from '../BaseForm/BaseForm';
import { addDriver, showError, clearErrors } from '../../redux/actions/drivers';

interface Props {
  model: any;
  fields: any;
  values: any;
  id: number;
  onUpdate: Function;
  dispatch: Function;
  item: any;
  disable: boolean;
  showHeading: boolean;
  isTypeForm?: boolean;
  meta?: any;
  handleValidation?: (data: any, isIndex: (index: number) => boolean) => any;
  resetFields?: Array<string>;
}

class DriverCreateForm extends BaseForm<Props> {
  protected static defaultProps: any = {
    fields: BaseForm.fields.drivers.create,
    onUpdate: () => {},
    showHeading: true,
  };

  constructor(props) {
    super(props, {
      onSubmit: addDriver,
      name: 'Driver',
      action: 'Add',
      type: 'create',
      isTypeForm: true,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    if (this.props.handleValidation) {
      return this.props.handleValidation(data, isIndex);
    }
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.first_name)) {
      this.props.dispatch(showError('Please specify a first name'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.last_name)) {
      this.props.dispatch(showError('Please specify a last name'));
      return false;
    }
    if (isIndex(3) && BaseForm.validator.isEmpty(String(data.phone_number))) {
      this.props.dispatch(showError('Please specify a phone number'));
      return false;
    }

    // If a company is provided assign it to the driver
    if (this.props.meta && this.props.meta.company_id) {
      return assign({}, data, {
        company_id: Number(this.props.meta.company_id),
      });
    }

    return data;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    const resetFields = this.props.resetFields || ['name', 'phone_number'];
    resetFields.forEach((resetField) =>
      dispatch(actions.change(`create.${resetField}`, '')),
    );
  }
}

const mapStateToProps = ({ drivers }) => ({
  model: drivers,
});

export default connect(mapStateToProps)(DriverCreateForm);
